<plyca-ui-accordion role="region" aria-labelledby="signature-accordion-header" [multiple]="true" [selected]="true" [header]="'SignatureTool.signatures' | translate">
  <ng-container *ngIf="file && file.signatures && file.signatures.length > 0">
    <ul class="list-unstyled project-files">
      <li *ngFor="let signature of signaturesList; let o = index" class="documetfile-detail d-inline-block w-100" aria-label="Signature item {{ o + 1 }}">
        <button (click)="validateSignDocument(signature, file)" class="d-inline signature-tool-accordion__button">
          <img alt="image" class="pr-1 align-top" src="assets/img/{{ signature.handWritten ? 'CERESManuscrita.gif' : 'CERES.gif' }}" style="width: 20px" />
          <span class="d-inline-block"
            ><strong>{{ signature.handWritten ? signature.supportUser?.person?.fullName : signature.signer }}</strong></span
          >
          <ul>
            <li *ngIf="signature.accountingUser?.identifier" class="documetfile-detail row">
              <span class="d-inline-block">
                <small class="text-muted"
                  ><strong>{{ 'General.user' | translate }} </strong></small
                >
                <small class="text-muted">{{ signature.accountingUser.identifier }}</small>
              </span>
            </li>
            <li *ngIf="signature.date" class="documetfile-detail row">
              <span class="d-inline-block">
                <small class="text-muted"
                  ><strong>{{ 'Signature.Details.Date' | translate }} </strong></small
                >
                <small class="text-muted">{{ signature.date | date: 'dd-MM-yyyy HH:mm' }}</small>
              </span>
            </li>
            <li *ngIf="signature.position" class="documetfile-detail row">
              <span class="d-inline-block">
                <small class="text-muted"
                  ><strong>{{ 'Signature.Details.Position' | translate }} </strong></small
                >
                <small class="text-muted">{{ signature.position }}</small>
              </span>
            </li>
            <li *ngIf="signature.comment" class="documetfile-detail row">
              <span class="d-inline-block">
                <small class="text-muted"
                  ><strong>{{ 'Signature.Details.Comment' | translate }} </strong></small
                >
                <small *ngIf="signature.comment" class="text-muted text-break">{{ signature.comment }}</small>
                <small *ngIf="!signature.comment" class="text-muted">{{ signature.remarks }}</small>
              </span>
            </li>
          </ul>
        </button>
      </li>
    </ul>
  </ng-container>
</plyca-ui-accordion>
